export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11015.9cf45c46.jpg";